/** Textes « clients » — le français fait foi. */
export const clients = {
  titre: 'Clients',
  sousTitreVide: "Chaque location part d'une fiche client",
  fiches: (n: number) => `${n} fiche(s)`,
  nouveau: 'Nouveau client',
  rechercher: 'Rechercher par nom ou téléphone',
  rechercherExemple: 'Bouzidi, 0661…',
  aucunCorrespond: 'Aucun client ne correspond',
  aucuneFiche: 'Aucune fiche client',
  premiere: 'Créer ma première fiche',
  autreOrthographe: 'Essayez avec une autre orthographe, ou seulement les premiers chiffres du téléphone.',
  videTexte: "La fiche porte la date de naissance et la date du permis : ce sont elles qui déclenchent les blocages de l'article 01 — 28 ans minimum, permis de 5 ans. Elle se crée aussi directement depuis une nouvelle location.",
  col: { nom: 'Nom', telephone: 'Téléphone', piece: 'Pièce', permis: 'Permis délivré le' },
  societe: 'Société',
  listeNoire: 'Liste noire',
  compteATerme: 'Compte a terme',
  ouvrir: 'Ouvrir',
  retirerTitre: (n: string) => `Retirer ${n} de la liste noire`,
  mettreTitre: (n: string) => `Mettre ${n} en liste noire`,
  retirerTexte: 'Le client redeviendra louable. Le motif du retrait reste au journal.',
  mettreTexte: "Aucune location ne pourra plus être créée pour ce client — l'écran le refusera en disant pourquoi. La décision et son motif restent au journal, avec votre nom.",
  motif: 'Motif',
  motifAide: "Obligatoire. C'est ce texte que l'agent lira au moment du refus.",
  motifRetraitExemple: 'Ex. : dette réglée le 30/08, client à nouveau accepté.',
  motifMiseExemple: 'Ex. : deux voitures rendues accidentées, solde impayé depuis mars.',
  annuler: 'Annuler',
  enregistrementImpossible: 'Enregistrement impossible.',
  retirer: 'Retirer de la liste noire',
  mettre: 'Mettre en liste noire',
  clientListeNoire: 'Client en liste noire',
  modifierFiche: 'Modifier la fiche',
  article01: 'Article 01',
  conforme: 'Conforme',
  conformeTexte: (age?: number, permis?: number) => `${age} ans · permis depuis ${permis} ans.`,
  coordonnees: 'Coordonnées',
  telephone: 'Téléphone',
  email: 'E-mail',
  adresse: 'Adresse',
  naissance: 'Naissance',
  lieuNaissance: (l: string) => `a ${l}`,
  permis: 'Permis',
  historique: (n: number) => `Historique — ${n} location(s)`,
  colHisto: { numero: 'N°', vehicule: 'Véhicule', periode: 'Période', total: 'Total' },
};
